import {useParams} from 'react-router-dom';

import {defaultTo} from 'ramda';

type TiresOrderIdParams = {
  id?: string;
};

export function useTiresInventoryUrl() {
  const params = useParams<TiresOrderIdParams>();

  return {orderId: defaultTo('', params.id)};
}
